import React from 'react'
import Markdown from 'react-markdown'
import calendarIcon from './icons/calendar.svg'
import AbortionDetails from './ABFinderShared/AbortionDetails.jsx'
import TelehealthAbortionDetails from './ABFinderShared/TelehealthAbortionDetails.jsx'
import './AbortionServices.scss'

const locale = document.documentElement.lang || 'en'

const AbortionServices = ({
  gestationalWeeksAndDays,
  stateAbortionLimit,
  lexicon,
  clinic,
  stateAbortionLaw,
}) => {
  return (
    <div className="AbortionServices">
      <div className="abortion-section">
        <h3>{lexicon.get('pregnancy_stage')}</h3>
        <div className="gestational-age-container">
          <div className="gestational-age-icon">
            <img src={calendarIcon} alt="" />
          </div>
          <div className="gestational-age-text">
            <p>
              {lexicon.get('provider_offers')}
              <strong>{gestationalWeeksAndDays}</strong>
            </p>
            <p>{stateAbortionLimit}</p>
          </div>
        </div>
      </div>

      <AbortionDetails
        clinic={clinic}
        stateAbortionLaw={stateAbortionLaw}
        lexicon={lexicon.subset('AbortionDetails')}
      />

      <TelehealthAbortionDetails
        clinic={clinic}
        lexicon={lexicon.subset('AbortionDetails')}
        locale={locale}
      />

      <Markdown source={lexicon.get('visit_abfinder')} />
    </div>
  )
}

export default AbortionServices
